export default {
  en: {
    shareTo: 'Share to',
    Email: 'Email',
    Print: 'Print',
    Share: 'Share',
    Tweet: 'Tweet',
    Pin: 'Pin',
  },
  es: {
    shareTo: 'Compartir con',
    Email: 'Email',
    Print: 'Imprimir',
    Share: 'Compartir',
    Tweet: 'Tweet',
    Pin: 'Pin',
  },
  pt: {
    shareTo: 'Compartilhe no',
    Email: 'E-mail',
    Print: 'Imprimir',
    Share: 'Compartilhe',
    Tweet: 'Tweet',
    Pin: 'Pin',
  },
};
